import React from 'react'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbIcon from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_icon'
import { conditionalLinkTarget, concatStrings } from '@dfb/gatsby-dfb-theme/src/components/utilities'
import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

interface Link {
  link?: string
  link_text?: string
  link_obj?: Record<string, unknown>
}

interface MFurtherLinksData {
  headline?: string
  layout?: 'left' | 'right' | string
  links?: Array<Link>
}

interface MFurtherLinksProps {
  data: MFurtherLinksData
}

function MFurtherLinks(props: MFurtherLinksProps) {
  const t = useTranslations()
  if (!(props.data.links?.length > 0)) {
    return null
  }

  return (
    <Section
      baseClass={concatStrings(
        'm-FurtherLinks',
        props.data.layout === 'left' && 'm-FurtherLinks--left-aligned',
        props.data.layout === 'right' && 'm-FurtherLinks--right-aligned'
      )}
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-FurtherLinks-wrapper">
        <div className="m-FurtherLinks-container">
          <div className="m-FurtherLinks-content">
            <div className="m-FurtherLinks-headline">
              <DfbHeadline headline_level="h4" headline={props.data.headline || t('further_links.headline')} />
            </div>
            <ul className="m-FurtherLinks-linkList">
              {props.data.links.map((item, index) => (
                <li className="m-FurtherLinks-linkWrapper" key={index}>
                  <DfbIcon icon_type="Arrow Right" />
                  <div className="m-FurtherLinks-link">
                    <a className="dfb-Textlink" href={item.link} {...conditionalLinkTarget(item.link, item.link_obj)}>
                      {item.link_text}
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MFurtherLinks
